/* import __COLOCATED_TEMPLATE__ from './campaign-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

type BannerVariant = 'paywall' | 'success';

const VARIANT_CLASSES: Record<BannerVariant, string> = {
  paywall: 'border-paywall-border bg-paywall-container',
  success: 'border-success-border bg-success-container',
};

interface Signature {
  Element: HTMLDivElement;
  Args: {
    bannerText: string;
    bannerCtaText?: string;
    onCtaClick?: () => void;
    variant?: BannerVariant;
    showTalkToSpecialist?: boolean;
    syntheticsSelector?: string;
  };
}

export default class CampaignBanner extends Component<Signature> {
  @service declare purchaseAnalyticsService: $TSFixMe;

  get variantClasses(): string {
    return VARIANT_CLASSES[this.args.variant ?? 'paywall'];
  }

  @action
  onProductSpecialistClick() {
    this.purchaseAnalyticsService.trackEvent({
      action: 'clicked',
      object: 'ask_product_specialist',
      context: 'campaign_banner',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Banners::CampaignBanner': typeof CampaignBanner;
    'banners/campaign-banner': typeof CampaignBanner;
  }
}
